export async function post(url, data = {}) {
    const request = await postData(url, data);

    if (request.status === 403) {
        window.location.replace(window.location.origin + "/")
    } else if (request.status === 401) {
        localStorage.clear();
        window.location.replace(window.location.origin)
    } else {
        return request;
    }
}

export async function postWithToken(url, token, data = {}) {
    const request = await postDataWithToken(url, token, data);

    if (request.status === 403) {
        window.location.replace(window.location.origin + "/")
    } else if (request.status === 401) {
        localStorage.clear();
        window.location.replace(window.location.origin)
    } else {
        return request;
    }
}

function postDataWithToken(endpoint = '', token, data = {}) {
    const url = `${window.location.origin}/api/${endpoint}`;
    const body = JSON.stringify(data);

    return fetch(url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        mode: 'cors',
        headers: getHeaders(token),
        body: body, // body data type must match "Content-Type" header
    })
        .then(response => response); // parses JSON response into native JavaScript objects 
}

export async function get(endpoint, token = null) {
    const url = `${window.location.origin}/api/${endpoint}`;

    const request = await fetch(url, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        mode: 'cors',
        headers: getHeaders(token),
    })
        .then(response => response); // parses JSON response into native JavaScript objects 

    if (request.status === 403) {
        window.location.replace(window.location.origin + "/")
    } else if (request.status === 401) {
        localStorage.clear();
        window.location.replace(window.location.origin)
    } else {
        return request;
    }
}

function getHeaders(token = null) {
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': localStorage.getItem('language') || 'ru'
    };

    if (!!token) {
        headers.Authorization = `Bearer ${token}`
    }

    return headers;
}

function postData(endpoint = '', data = {}) {
    const url = `${window.location.origin}/api/${endpoint}`;
    const body = JSON.stringify(data);

    return fetch(url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        mode: 'cors',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: body, // body data type must match "Content-Type" header
    })
        .then(response => response); // parses JSON response into native JavaScript objects 
}

export async function postFormData(endpoint = '', data = {}, token) {
    const url = `${window.location.origin}/api/${endpoint}`;

    const request = await fetch(url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        mode: 'cors',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: data, // body data type must match "Content-Type" header
    })
        .then(response => response); // parses JSON response into native JavaScript objects 

    if (request.status === 403) {
        window.location.replace(window.location.origin + "/admin")
    } else if (request.status === 401) {
        localStorage.clear();
        window.location.replace(window.location.origin)
    } else {
        return request;
    }
}

